import { Fence, FenceProperties } from "@/types/base-model.ts";
import { layerIdFences } from "@/types/map-config.ts";
import { featureCollection } from "@turf/helpers";
import { FeatureCollection } from "@movinglayers/map";

export const convertFenceToFeatureCollection = (fences: Fence[]): FeatureCollection => {
    const features = fences.flatMap((fence) => {
        const properties: FenceProperties = {
            documentId: fence.documentId,
            name: fence.name,
            //area: fence?.designated_area?.name ?? "", // should area be displayed too?
            size: fence.size_m2,
            layer: layerIdFences
        };
        return fence?.geoJSON?.features.map((feature: any) => {
            const fenceFeature = Object.assign({}, feature);
            Object.assign(fenceFeature.properties, properties);
            return fenceFeature;
        });
    });
    return featureCollection(features);
}

